import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.file && typeof _vm.file == 'object' && !!_vm.file.url)?_c(VTooltip,{staticClass:"d-inline",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({attrs:{"color":"primary"},on:{"click":function($event){return _vm.newWindow(_vm.file.url)}}},'v-icon',attrs,false),on),[_vm._v(" mdi-file-document-outline ")])]}}],null,false,1375095868)},[_c('span',[_vm._t("tooltip",[_vm._v(_vm._s(_vm.file.filename))])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }